<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-input size="medium" disabled :placeholder="placeholder" show-word-limit :rows="2" type="textarea"/>
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <el-input size="medium" v-model="_value" clearable :maxlength="255" :placeholder="placeholder" show-word-limit :rows="rows" type="textarea">
        <el-button v-if="enableScan" slot="append" icon="el-icon-full-screen" @click="scanCode"></el-button>
      </el-input>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <field v-model="_value" :rows="rows" autosize type="textarea"
             maxlength="2048" :placeholder="placeholder" show-word-limit>
        <template #right-icon v-if="enableScan">
          <i class="el-icon-full-screen" @click="scanCode"></i>
        </template>
      </field>
      <scan-code v-model="visible" @ok="scanOk"></scan-code>
    </div>
    <div v-else>
      <el-input disabled size="medium" v-model="_value" clearable :maxlength="5000" :placeholder="placeholder" show-word-limit :rows="6" type="textarea" />
    </div>
  </div>
</template>

<script>
import {Field, Toast} from 'vant'
import ScanCode from "@/components/common/ScanCode";
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "TextareaInput",
  components: {Field, ScanCode},
  props:{
    value: {
      type: String,
      default: null
    },
    placeholder:{
      type: String,
      default: '请输入内容'
    },
    enableScan:{
      type: Boolean,
      default: false
    },
    rows:{
      type: Number,
      default: 5
    }
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      visible: false,
      popupStyle: {
        height: '100%',
        width: '100%',
        background: 'black',
        opacity: '0.5'
      }
    }
  },
  methods: {
    scanCode(){
      this.visible = true
    },
    scanOk(code){
      this._value += code + '\n'
      Toast.success('扫码成功')
    }
  }
}
</script>

<style scoped>
  .text-container {
    word-wrap: break-word; /* 或者使用 overflow-wrap: break-word; */
    white-space: normal; /* 确保文本可以换行 */
  }
  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: black;
    -webkit-text-fill-color: black !important; /* 关键属性，覆盖 iOS 默认样式 */
    opacity: .5;
  }
</style>
